export enum DynamicQRStatus {
  notFound = 'notFound',
  notActive = 'notActive',
  overdue = 'overdue',
}
